import { useSelector } from 'react-redux';

import { Button, Flex, Tag, Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import ReviewView from './UploadedPDFView';

type Props = {
  jobAndProposalId: string;
  OnProceedForward: () => void;
};

const InProgress = ({ OnProceedForward }: Props) => {
  const jobProcess = useSelector((state: RootState) => state.singleJobProcess);

  const handleProceedForward = () => {
    OnProceedForward();
  };
  const latestReview =
    jobProcess.review && jobProcess.review.length > 0
      ? jobProcess.review[0]
      : null;

  return (
    <>
      {latestReview &&
      !latestReview.isActive &&
      latestReview.reviewStatus === 'PENDING' ? (
        <ReviewView review={latestReview} />
      ) : (
        <Flex direction="column" gap="10px">
          <Typography>Ready to roll on the task?</Typography>
          <Button
            variant="secondary"
            style={{ padding: '15px 20px' }}
            onClick={handleProceedForward}
          >
            <Typography fontColor="white">Proceed Forward</Typography>
          </Button>
        </Flex>
      )}

      <div style={{ marginTop: '10px' }}>
        {jobProcess?.status === 'REVIEW' && <Tag>Sent For Review</Tag>}
        {jobProcess.status === 'COMPLETED' && <Tag>Completed</Tag>}
      </div>
    </>
  );
};

export default InProgress;
